import React, { useState, useEffect, useRef } from "react";
import { AdjustmentsVerticalIcon } from "@heroicons/react/24/outline";
import CreditTabs from "./tabs";
import NewCreditRequest from "./NewCreditRequest";
import CreditRequestFilter from "./CreditRequestFilters";
import {
  useGetAllCreditRequestsQuery,
  useLazyGetAllCreditRequestsQuery,
  useLazyGetSortedCreditRequestsQuery,
} from "../../../../store/admin/creditRequests";
import ClosedCreditRequest from "./ClosedCreditRequest";
import Loader from "../../../commons/Loader";
import SpecificLoader from "../../../commons/SpecificLoader";
import NumberSkeleton from "../../../commons/Skeleton/NumberSkeleton";

const CreditStatues = { New: "pending", Closed: "approved,denied" };

const DashboardAdminCredit = () => {
  const dropdownRef = useRef(null)
  const [filterActive, setFilterActive] = useState(false);
  const [selectedTab, setSelectedTab] = useState("New");
  const [selectedSortOption, setSelectedSortOption] = useState("");
  const [creditRequests, setCreditRequests] = useState([]);
  
  const [
    getSortedCreditReuqests,
    {
      data: sortedCreditReuqests,
      isLoading: sortedCreditRequestsLoader,
      isSuccess: sortedCreditRequestsSuccess,
    },
  ] = useLazyGetSortedCreditRequestsQuery();

  const { data: allCreditRequests, isLoading: allCreditRequestsLoader } = useGetAllCreditRequestsQuery({
    statuses: "pending",
  });
  const [getUpdatedStatusesData, { data: allStatusesCreditRequests, isLoading: allStatusesCreditRequestsLoader  }] =
    useLazyGetAllCreditRequestsQuery();

  const handleOutsideClick = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setFilterActive(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    if (allCreditRequests) {
      setCreditRequests(allCreditRequests);
    }
  }, [allCreditRequests]);

  useEffect(() => {
    if (allStatusesCreditRequests) {
      setCreditRequests(allStatusesCreditRequests);
    }
  }, [allStatusesCreditRequests]);

  useEffect(() => {
    if (sortedCreditRequestsSuccess && !sortedCreditRequestsLoader) {
      setFilterActive(false);
      setCreditRequests(sortedCreditReuqests);
    }
  }, [sortedCreditRequestsSuccess, sortedCreditReuqests]);

  const handleTabChange = (tabName) => {
    if (tabName === "Closed") {
      getUpdatedStatusesData({ statuses: "approved,denied" });
    }
    if (tabName === "New") {
      getUpdatedStatusesData({ statuses: "pending" });
    }
    setSelectedTab(tabName);
  };

  const handleActiveCreditFilter = () => {
    setFilterActive((prevState) => !prevState);
  };

  const handleApplyClick = () => {
    if (selectedSortOption === "Newest") {
      getSortedCreditReuqests({
        sort: "desc",
        statuses: CreditStatues[selectedTab],
      });
    } else if (selectedSortOption === "Oldest") {
      getSortedCreditReuqests({
        sort: "asc",
        statuses: CreditStatues[selectedTab],
      });
    }
  };

  const isLoading = allCreditRequestsLoader || allStatusesCreditRequestsLoader
  return (
    <div className="col-span-12">
      <div className="flex md:items-center justify-between flex-col sm:flex-row gap-3.5 mb-5">
        <div className="flex items-center gap-[6px] xl:gap-[10px]">
          <div className="flex items-center gap-[10px]">
            <h3
              className="text-xl xl:text-2xl font-bold leading-[130%] text-[#04091E] cursor-pointer"
              // onClick={handleGoBack}
            >
              Credit Requests
            </h3>
          </div>
          <span className="text-[#485868]">&#8226;</span>
          <h3 className="text-xl xl:text-2xl font-bold leading-[130%] text-[#485868]">
            {creditRequests?.data?.length??<NumberSkeleton/>}
          </h3>
        </div>
        <div className="flex sm:items-center flex-col sm:flex-row gap-3.5 md:gap-5">
          <div className="relative max-w-[340px] sm:max-w-auto">
            <button
              className={`max-w-[340px] sm:max-w-auto w-full sm:w-12 h-12 flex items-center justify-center gap-2.5 sm:gap-0 rounded-[10px] col-span-6 transition-all ${
                filterActive
                  ? "bg-[#D2ECFF] text-primary"
                  : "bg-[#EBEFF3] text-[#485868]"
              }`}
              onClick={handleActiveCreditFilter}
            >
              <AdjustmentsVerticalIcon className="w-6 h-6" />
              <span
                className={`text-sm font-bold leading-[160%] block sm:hidden ${
                  filterActive ? "text-primary" : "text-[#485868]"
                }`}
              >
                Filter
              </span>
            </button>
            <div
              ref = {dropdownRef}
              className={`notificationDropdown absolute right-0 top-[55px] sm:top-[60px] z-10 opacity-0 ${
                filterActive ? "notificationOpen" : ""
              }`}
            >
              <CreditRequestFilter
                setFilterActive={setFilterActive}
                filterActive={filterActive}
                handleApplyClick={handleApplyClick}
                setSelectedSortOption={setSelectedSortOption}
                selectedSortOption={selectedSortOption}
                loader={sortedCreditRequestsLoader}
              />
            </div>
          </div>
          <CreditTabs
            selectedTab={selectedTab}
            onSelectTab={handleTabChange}
            isReview={true}
          />
        </div>
      </div>
      {selectedTab === "New" && (
        <NewCreditRequest
          creditRequestDataCard={creditRequests?.data}
          meta={creditRequests.meta}
          getUpdateData={(page, perPage) => {
            getUpdatedStatusesData({
              page,
              perPage,
              statuses: CreditStatues[selectedTab],
            });
          }}
        />
      )}
      {selectedTab === "Closed" && (
        <ClosedCreditRequest
          creditRequestDataCard={creditRequests?.data}
          meta={creditRequests.meta}
          getUpdateData={(page, perPage) => {
            getUpdatedStatusesData({
              page,
              perPage,
              statuses: CreditStatues[selectedTab],
            });
          }}
        />
      )}
      {/* {selectedTab === "History to Active" && (
        <ActiveCreditRequest creditRequestDataCard={creditRequestDataCard} />
      )} */}
    </div>
  );
};

export default DashboardAdminCredit;
